import { ReactElement, useEffect, useState } from "react";
import { Box } from "@twilio-paste/core/box";

import {
  WiseOwlBlock,
  WiseOwlEventEnum,
  WiseOwlIngress,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";
import BlockRenderer from "../blockRenderer";
import { useGetHome, useWiseOwlContext } from "../../hooks";
import { OscPreChatHeader, PreChatLoader } from "./sub";

const PreChat = (): ReactElement => {
  const [blocks, setBlocks] = useState<WiseOwlBlock[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { applicationProps, isOneAdmin } = useWiseOwlContext();
  const { mutateAsync: getHomeContent } = useGetHome(applicationProps);

  const { onError, onEvent } = applicationProps;

  useEffect(() => {
    /**
     * This condition is specific for One Admin which is not
     * up-to-date with the latest WO feature changes
     */
    if (!isOneAdmin) {
      handleGetHomeContent();
    } else {
      setIsLoading(false);
    }
  }, []);

  const handleGetHomeContent = async () => {
    try {
      const response = await getHomeContent({});

      if (onEvent) {
        onEvent({
          eventType: WiseOwlEventEnum.getPreChatContent,
          data: {},
        });
      }

      setBlocks(response.data.blocks);
    } catch (err) {
      if (onError) {
        onError({
          eventType: WiseOwlEventEnum.getPreChatContent,
          data: {},
          error: err as Error,
        });
      }
    }
    setIsLoading(false);
  };

  const renderPreChatHeader = (): ReactElement => {
    switch (applicationProps.ingress) {
      case WiseOwlIngress.console: {
        return <></>;
      }
      /**
       * Default to any E2 ingress
       * - OSC gated/ungated
       * - Zendesk
       * - One Admin
       * - Salesforce
       */
      default: {
        return <OscPreChatHeader />;
      }
    }
  };

  return (
    <Box overflowY={"auto"} position={"relative"}>
      {isLoading && <PreChatLoader />}

      {!isLoading && (
        <>
          {renderPreChatHeader()}
          {/** Recommended Prompts */}
          <BlockRenderer blocks={blocks} />
        </>
      )}
    </Box>
  );
};

export default PreChat;
